import script from "./HomeA.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeA.vue?vue&type=script&setup=true&lang=js"

import "./HomeA.vue?vue&type=style&index=0&id=54754591&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54754591"]])

export default __exports__